import { createStore, applyMiddleware, compose } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import thunk from 'redux-thunk'
import { createBrowserHistory } from 'history'
import rootReducer from './store/modules'

import api from './store/middleware/api'
import debounce from './store/middleware/debounce'
import dispatchLog from './store/middleware/dispatchLog'

export const history = createBrowserHistory({ basename: '/' })

const initialState = {}
const enhancers = []
const middleware = [
    thunk,
    // Disable logging to make sure it's not interfering with the demo
    // This might or might not be re-examined once the demo is over
    dispatchLog,
    debounce,
    api,
    routerMiddleware(history),
]

if (process.env.NODE_ENV === 'development') {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension())
    }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers)

const composedEnhancersForTesting = compose(
    applyMiddleware(thunk, api, routerMiddleware(history)),
    ...enhancers
)

const configureStore = (
    preloadedState = initialState,
    configureStoreForTests = false
) => {
    const store = createStore(
        rootReducer(history),
        preloadedState,
        configureStoreForTests ? composedEnhancersForTesting : composedEnhancers
    )

    if (module.hot) {
        module.hot.accept('./store/modules', () => {
            const nextRootReducer = require('./store/modules').default
            store.replaceReducer(nextRootReducer)
        })
    }

    return store
}

export default configureStore
